// extracted by mini-css-extract-plugin
export default {"wrapper":"CapsuleDetailPage_wrapper__RYRu6"};